import React, { useEffect, useState } from "react";
import { Row, Image, Layout, List, Typography, Col, Breadcrumb } from "antd";
import "../aboutMainpage/styles/index.less";
import { aboutus_get } from "../../services/aboutus";
import { useTranslation } from "react-i18next";


const { Content } = Layout;
const { Title, Text, Paragraph } = Typography;

type Props = {};

const Aboutmainpage = (props: Props) => {
    const [isLoading, setIsLoading] = useState(true);
    const [htmlContent, setHtmlContent] = useState<string>("");
    const [imageSrc, setImageSrc] = useState<string | null>(null);
    const { t } = useTranslation();

    useEffect(() => {
      const fetchData = async () => {
        setIsLoading(true);
        await getAboutDetail();
        setIsLoading(false);
      };
      fetchData();
    }, []);

    const getAboutDetail = async () => {
      try {
        const res = await aboutus_get();
    
        if (res.data) {
          const rawDetails = JSON.parse(res.data[0].detail);
          let extractedHtml = "";
          let uploadedImgUrl = "";
    
          if (Array.isArray(rawDetails)) {
            extractedHtml = rawDetails.map((item) => item.text).join("");
            uploadedImgUrl = rawDetails[0]?.uploadedImgUrl || "";
          } else if (rawDetails && rawDetails.text) {
            extractedHtml = rawDetails.text;
            uploadedImgUrl = rawDetails.uploadedImgUrl || "";
          }
    
          setHtmlContent(extractedHtml);
    
          if (uploadedImgUrl) {
            const isExternal = /^(https:\/\/|http:\/\/|www\.)/i.test(uploadedImgUrl);
            const fullImage = isExternal
              ? uploadedImgUrl
              : `${process.env.REACT_APP_API}${uploadedImgUrl}`;
            setImageSrc(fullImage);
          } else {
            setImageSrc(null); // ✅ ไม่มีรูป = ไม่แสดงภาพ
          }
    
        } else {
          console.error("No details found in the response");
        }
      } catch (error) {
        console.error("Failed to fetch news details", error);
      }
    };
    


  return (
    <Layout>
      <Content className="about-layout">
        {/* header */}
        <div>
          <Row justify="space-between" align="middle">
          <Breadcrumb
              separator=">"
              items={[
                {
                  title: (
                    <span style={{ fontWeight: "bold" }}>
                      {t("About Us")}
                    </span>
                  ),
                },
              ]}
            />
          </Row>
          <hr />
        </div>


        {imageSrc && (
          <div style={{ textAlign: "center", padding: "20px 0px" }}>
            <Image
              src={imageSrc}
              alt="About Us"
              style={{ width: "50%" }}
              preview={false}
            />
          </div>
        )}

        <div
          className="container-aboutus"
          dangerouslySetInnerHTML={{ __html: htmlContent }}
        />
      </Content>
    </Layout>
  );
};

export default Aboutmainpage;
